module.exports = __webpack_public_path__ + "static/logo501-ffa2b401eb66bba65e29296434b58e94.png";